import { render, staticRenderFns } from "./PackingLists.vue?vue&type=template&id=545357b6&scoped=true&"
import script from "./PackingLists.vue?vue&type=script&lang=js&"
export * from "./PackingLists.vue?vue&type=script&lang=js&"
import style0 from "./PackingLists.vue?vue&type=style&index=0&id=545357b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545357b6",
  null
  
)

export default component.exports